import { core } from '@icc/shared/helpers';
import { IWindowConfiguration } from '../window-configuration';

export function changesInVersion23(
    oldConfiguration: any,
): IWindowConfiguration {
    const configuration: IWindowConfiguration = {
        ...core.copy(oldConfiguration),
    };

    if (configuration.type === 'door') {
        let doorFrameAndSashShortening = 0
        if(configuration.doorSizes.shortening > 0) {
            doorFrameAndSashShortening = Math.abs(configuration.doorSizes.shortening - configuration.doorSizes.frameShortening);
        }
        configuration.height += doorFrameAndSashShortening;
        ([
            'height',
            'h1',
            'h2',
            'h3',
        ] as const).forEach((field) => {
            if (configuration.shape[field] != null && configuration.shape[field] !== 0) {
                configuration.shape[field] += Number(doorFrameAndSashShortening);
            }
        });
    }

    return configuration;
}